// extracted by mini-css-extract-plugin
export default {"cardGrid":"WhitepaperIndex-module__cardGrid__CTNkXbA","layoutGrid":"WhitepaperIndex-module__layoutGrid__yHNcoZH","filtersColumn":"WhitepaperIndex-module__filtersColumn__BN8nTxE"};